export default {
  // Campus specific texts
  phone: 'Phone',
  address2Optional: '2 (Optional)',
  postalCode: 'Postal code',
  institutionNotFound: 'Institution not found!!!',
}
